// import './companyprofile.css';
import Footer from "./footer";
import Homecarousel from "./homecarousel";
import Navbar from "./navbar";

const CompanyProfile = () => {
	return (
		<div>
			<Navbar />
			<div>
				<Homecarousel />
			</div>
			{/* Section 1 */}
			<div className="section">
				<div className="section-inner">
					<div className="text-container">
						<p>
							<b
								style={{
									fontFamily: "Rajdhani, sans-serif",
									fontSize: "30px",
									fontWeight: 500,
									height: "30px",
									letterSpacing: "0.5px",
									lineHeight: "30px",
								}}>
								Global Academy For Food Safety & Sustainability Standards
							</b>
							<br />
							<span
								style={{
									fontFamily: "Rubik, sans-serif",
									fontSize: "16px",
									fontWeight: 700,
									height: "auto",
									letterSpacing: "0.5px",
									lineHeight: "26px",
								}}>
								An Initiative of Krishigap Digital Solutions Pvt Ltd
							</span>
							<br />
							(CIN: U62013TS2023PTC172865)
							<br />
							<br />
							<span
								style={{
									fontSize: "16px",
									fontWeight: 400,
									height: "88px",
									letterSpacing: "0.5px",
									lineHeight: "26px",
								}}>
								Founded in May 2023, Krishigap Digital Solutions Pvt Ltd
								launched the Global Academy for Food Safety & Sustainability
								Standards, India’s first AI-powered learning and standards
								compliance platform for the agri-food sector — designed to
								empower farmer organizations, food processors, exporters, and
								institutions to meet global food safety and sustainability
								standards with confidence
							</span>
						</p>
					</div>
				</div>
			</div>

			<div className="section">
				<div className="section-inner">
					<div>
						<div className="bottom-section">
							{/* Vision */}
							<div className="vision" style={{ backgroundColor: "#bbe4a3" }}>
								<div className="icon">
									<i aria-hidden="true" className="fa fa-eye"></i>
								</div>
								<div className="text">
									<h3>Vision</h3>
									<p>
										To establish India as a global leader in safe, sustainable,
										and certified food systems.
									</p>
								</div>
							</div>

							{/* Mission */}
							<div className="mission" style={{ backgroundColor: "#bbe4a3" }}>
								<div className="icon">
									<i aria-hidden="true" className="fas fa-atom"></i>
								</div>
								<div className="text">
									<h3>Mission</h3>
									<p>
										To scale a global AI-powered platform delivering expert-led
										training, model farm demonstrations, and digital compliance
										tools—enabling rapid, scalable adoption of food safety and
										sustainability standards across the agri-food ecosystem.
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			{/* Section 2 */}
			<div className="section section-2">
				<div className="section-inner">
					<div className="content-container">
						<div className="heading-1" style={{ marginBottom: "0rem" }}>
							<h2>What We Offer :</h2>
						</div>
						<br />
						<div className="text-container-2" style={{ width: "100%" }}>
							<span>
								To establish India as a global leader in safe, sustainable, and
								certified food systems.
							</span>
							<br />
							<br />
							<ul
								style={{
									margin: "0px",
									padding: "0px",
									display: "flex",
									flexDirection: "column",
									gap: "10px",
								}}>
								<li style={{ margin: "0px" }}>
									<div className="rc-list">
										<div className="rc-icon">
											<svg
												aria-hidden="true"
												className="e-font-icon-svg e-fas-leaf"
												viewBox="0 0 576 512"
												xmlns="http://www.w3.org/2000/svg">
												<path d="M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"></path>
											</svg>
										</div>
										<span className="koul-text">
											<b> Self-paced and expert-led training </b>– Learn at your
											own pace or join live sessions led by standards experts.
										</span>
									</div>
								</li>
								<li style={{ margin: "0px" }}>
									<div className="rc-list">
										<div className="rc-icon">
											<svg
												aria-hidden="true"
												className="e-font-icon-svg e-fas-leaf"
												viewBox="0 0 576 512"
												xmlns="http://www.w3.org/2000/svg">
												<path d="M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"></path>
											</svg>
										</div>
										<span className="koul-text">
											<b>Model Farm</b> – See best practices in action and you
											can replicate success on your own farm.
										</span>
									</div>
								</li>
								<li style={{ margin: "0px" }}>
									<div className="rc-list">
										<div className="rc-icon">
											<svg
												aria-hidden="true"
												className="e-font-icon-svg e-fas-leaf"
												viewBox="0 0 576 512"
												xmlns="http://www.w3.org/2000/svg">
												<path d="M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"></path>
											</svg>
										</div>
										<span className="koul-text">
											<b> TraceAudit™ </b>– Our digital compliance tool that
											streamlines standards compliances, boosts transparency,
											and builds buyer & certifiers trust before the audit even
											begins.
										</span>
									</div>
								</li>
							</ul>
							<br />
							<b>The Impact:</b>
							<br />
							Our solutions drive{" "}
							<b>
								income growth, premium market access, climate resilience,
							</b>{" "}
							and <b>widespread standards adoption</b> — making your business
							ready to compete on the global stage.
						</div>
					</div>
				</div>
			</div>

			{/* Section 3 */}
			<div className="section">
				<div className="section-inner">
					<div className="content-container">
						<div className="heading-1" style={{ marginBottom: "0rem" }}>
							<h2>Recognized Exellence :</h2> <br />
						</div>
						<div className="text-container" style={{ width: "100%" }}>
							<span>
								Selected under the prestigious Conquest Initiative 2024 by BITS
								Pilani and Microsoft Startups Founders Hub — unlocking:
							</span>
							<br />
							<br />
							<ul style={{ margin: "0px", padding: "0px" }}>
								<li style={{ margin: "0px" }}>
									<div className="rc-list">
										<div className="rc-icon">
											<svg
												aria-hidden="true"
												className="e-font-icon-svg e-fas-leaf"
												viewBox="0 0 576 512"
												xmlns="http://www.w3.org/2000/svg">
												<path
													fill="white"
													d="M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"></path>
											</svg>
										</div>
										<span className="koul-text">
											Technical advisory and consulting support
										</span>
									</div>
								</li>
								<li style={{ margin: "0px" }}>
									<div className="rc-list">
										<div className="rc-icon">
											<svg
												aria-hidden="true"
												className="e-font-icon-svg e-fas-leaf"
												viewBox="0 0 576 512"
												xmlns="http://www.w3.org/2000/svg">
												<path
													fill="white"
													d="M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"></path>
											</svg>
										</div>
										<span className="koul-text">
											Up to USD 150,000 in Azure credits
										</span>
									</div>
								</li>
								<li style={{ margin: "0px" }}>
									<div className="rc-list">
										<div className="rc-icon">
											<svg
												aria-hidden="true"
												className="e-font-icon-svg e-fas-leaf"
												viewBox="0 0 576 512"
												xmlns="http://www.w3.org/2000/svg">
												<path
													fill="white"
													d="M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"></path>
											</svg>
										</div>
										<span className="koul-text">
											Go-to-market support with Microsoft
										</span>
									</div>
								</li>
								<li style={{ margin: "0px" }}>
									<div className="rc-list">
										<div className="rc-icon">
											<svg
												aria-hidden="true"
												className="e-font-icon-svg e-fas-leaf"
												viewBox="0 0 576 512"
												xmlns="http://www.w3.org/2000/svg">
												<path
													fill="white"
													d="M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"></path>
											</svg>
										</div>
										<span className="koul-text">
											Access to advanced development tools and strengthened tech
											teams
										</span>
									</div>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>

			{/* Section 4 */}
			<div className="section section-2">
				<div className="section-inner">
					<div className="content-container">
						<div className="heading-1" style={{ marginBottom: "0rem" }}>
							<h2>Our Expertise</h2>
						</div>
						<br />
						<div className="text-container-2" style={{ width: "100%" }}>
							<span>
								“Our platform is powered by a team of standards experts and
								product value chain specialists, ensuring that every solution we
								offer is relevant, credible, and impactful.”
								<br />
								<br />
								<b>Why We Built This Platform</b>
								<br />
								<br />
								Today’s farmers organisations and SME food businesses face big
								hurdles:
							</span>
							<br />
							<br />
							<ul
								style={{
									margin: "0px",
									padding: "0px",
									display: "flex",
									flexDirection: "column",
									gap: "10px",
								}}>
								<li style={{ margin: "0px" }}>
									<div className="rc-list">
										<div className="rc-icon">
											<svg
												aria-hidden="true"
												className="e-font-icon-svg e-fas-leaf"
												viewBox="0 0 576 512"
												xmlns="http://www.w3.org/2000/svg">
												<path d="M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"></path>
											</svg>
										</div>
										<span className="koul-text">
											Complex certification and audit processes
										</span>
									</div>
								</li>
								<li style={{ margin: "0px" }}>
									<div className="rc-list">
										<div className="rc-icon">
											<svg
												aria-hidden="true"
												className="e-font-icon-svg e-fas-leaf"
												viewBox="0 0 576 512"
												xmlns="http://www.w3.org/2000/svg">
												<path d="M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"></path>
											</svg>
										</div>
										<span className="koul-text">
											Limited access to reliable, hands-on guidance
										</span>
									</div>
								</li>
								<li style={{ margin: "0px" }}>
									<div className="rc-list">
										<div className="rc-icon">
											<svg
												aria-hidden="true"
												className="e-font-icon-svg e-fas-leaf"
												viewBox="0 0 576 512"
												xmlns="http://www.w3.org/2000/svg">
												<path d="M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"></path>
											</svg>
										</div>
										<span className="koul-text">Low digital adoption</span>
									</div>
								</li>
								<li style={{ margin: "0px" }}>
									<div className="rc-list">
										<div className="rc-icon">
											<svg
												aria-hidden="true"
												className="e-font-icon-svg e-fas-leaf"
												viewBox="0 0 576 512"
												xmlns="http://www.w3.org/2000/svg">
												<path d="M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"></path>
											</svg>
										</div>
										<span className="koul-text">
											Shortage of skilled compliance professionals
										</span>
									</div>
								</li>
							</ul>
							<br />
							Meanwhile, standard owners and certifiers can’t offer direct
							implementation help — leaving a huge gap. That’s where we come in.
							The Global Academy bridges this gap with independent, expert-led,
							and tech-enabled support — so you’re not just certified, you’re
							market-ready, profitable, and future-proof.
						</div>
					</div>
				</div>
			</div>

			{/* Section 5 */}
			<div className="section">
				<div className="section-inner">
					<div className="content-container">
						<div className="heading-1" style={{ marginBottom: "0rem" }}>
							<h2>Standards Access Notice</h2>
							<br />
						</div>
						<div className="text-container" style={{ width: "100%" }}>
							<span>
								The Global Academy does not host or sell standards. Users must
								obtain copies of relevant standards directly from the respective
								standard publishers such as: ISO: www.iso.org,,BRCGS:
								www.brcgs.com,FSSC 22000: ( www.fssc.com,,GlobalG.A.P (
								www.globalgap.org) , QCI ( www.qcin.org) USDA ( www.usda.gov)
								Rainforest Alliance ( www.rainforest-alliance.org) ,APEDA (
								www.apeda.gov.in) , FSSAI ( www.fssai.org) etc.
							</span>
							<br />
							<br />
							{/* Refer to our disclaimer policy. */}
						</div>
					</div>
				</div>
			</div>

			{/* Section 6 */}
			<div className="section" style={{ marginTop: "-3rem" }}>
				<div className="section-inner">
					<div className="content-container">
						<div
							className="text-container"
							style={{ width: "100%", textAlign: "center", cursor: "pointer" }}
							onClick={() => (window.location.href = "./disclaimer")}>
							<span>Refer to our disclaimer policy.</span>
						</div>
					</div>
				</div>
			</div>

			<Footer />
		</div>
	);
};

export default CompanyProfile;
